import { Link } from "react-router-dom";
import { ArrowRight, Lock } from "lucide-react";

export default function SignupBlocked() {
  return (
    <div
      className="min-h-screen bg-[#0a0a0a] text-white flex items-center justify-center p-6"
      data-testid="signup-blocked-page"
    >
      <div className="max-w-xl w-full">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-white/10 bg-white/5 text-[10px] uppercase tracking-[0.3em] text-white/60">
          <Lock className="w-3 h-3" /> Subscriptions are tenant-scoped
        </div>
        <h1 className="mt-6 font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.95]">
          Subscribe via a<br /><span className="italic font-medium">studio storefront.</span>
        </h1>
        <p className="mt-6 text-white/60 font-light leading-relaxed">
          Vawworld doesn't run a single global catalogue. Each studio sells its own audience. Pick a
          studio below — or paste their storefront URL into your address bar — to subscribe.
        </p>
        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Link
            to="/s/studio-aurora"
            className="group bg-[#121212] border border-white/10 p-5 hover:border-white/30 transition-colors"
            data-testid="signup-blocked-aurora"
          >
            <div className="flex items-center justify-between">
              <span className="font-display font-bold text-lg">Studio Aurora</span>
              <ArrowRight className="w-4 h-4 text-white/30 group-hover:text-white transition-colors" />
            </div>
            <span className="text-xs text-white/45 mt-1 block">Indie cinema, reimagined.</span>
          </Link>
          <Link
            to="/s/indie-tales"
            className="group bg-[#121212] border border-white/10 p-5 hover:border-white/30 transition-colors"
            data-testid="signup-blocked-indie"
          >
            <div className="flex items-center justify-between">
              <span className="font-display font-bold text-lg">Indie Tales</span>
              <ArrowRight className="w-4 h-4 text-white/30 group-hover:text-white transition-colors" />
            </div>
            <span className="text-xs text-white/45 mt-1 block">Stories from the streets.</span>
          </Link>
        </div>
        <div className="mt-12 text-xs text-white/40">
          Already have an account?{" "}
          <Link to="/login" className="text-white underline decoration-white/30 underline-offset-4 hover:decoration-white" data-testid="signup-blocked-login-link">
            Sign in here
          </Link>
        </div>
      </div>
    </div>
  );
}
